import { render, staticRenderFns } from "./PatentList.vue?vue&type=template&id=0eb09b88&scoped=true"
import script from "./PatentList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PatentList.vue?vue&type=style&index=0&id=0eb09b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb09b88",
  null
  
)

export default component.exports